import apiPaths from '../api-paths.js';

export default {
  list(query = '') {
    return axios.get(`${ apiPaths.STAFF }${ query }`);
  },
  index(query = '') {
    return axios.get(`${ apiPaths.STAFF }${ query }`);
  },
  search({ searchValue }) {
    return axios.post(`${ apiPaths.STAFF }/search`, { search: searchValue });
  },
  activateAccount({ id, original }) {
    return axios.post(`${ apiPaths.STAFF }/${ original }/activations`, { id });
  },
  deactivateAccount({ id, original }) {
    return axios.post(`${ apiPaths.STAFF }/${ original }/deactivations`, { id });
  },
};
